module.exports = __webpack_public_path__ + "img/snowman.34a32408.svg";